import React from "react";

export default function SQL_NOT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_NOT</h1>
      <p>This is the SQL_NOT component generated from the SQL JSON.</p>
    </div>
  );
}
